import ImporveSkill from "../component/ImporveSkill";
import Quote from "../component/Quote";
import HeroSection from "../component/HeroSection";
import CheifSection from "../component/CheifSection";
export default function Home() {
  return (
    <div>
      <HeroSection />
        <ImporveSkill />
        <Quote />
        <CheifSection />
    </div>
  )
}
